const validate = {
    isPhone: function (value) {
        let regex = /^(1)[0-9]{10}$/;
        return value && regex.test(value);
    },
}

export default validate;
